/**
 * Action Cards Section Component
 * Displays the main action cards for the VPE Dashboard
 * Extracted from VPEDashboard.tsx for better modularity
 */

import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Plus, Archive, Settings } from 'lucide-react';

interface ActionCardsSectionProps {
  onCreateGroupClick: () => void;
  onArchivedGroupsClick: () => void;
  onManageVPEClick: () => void;
}

const ActionCardsSection: React.FC<ActionCardsSectionProps> = ({
  onCreateGroupClick,
  onArchivedGroupsClick,
  onManageVPEClick,
}) => {
   return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-testid="ea-action-cards">
      <Card 
        className="cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-0 shadow-lg group rounded-2xl overflow-hidden"
        onClick={onCreateGroupClick}
        data-testid="ea-create-group-card"
      >
        <CardContent className="p-8 text-center relative">
          <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-pink-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="relative">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Plus className="h-8 w-8 text-white" />
            </div>
            <h3 className="font-bold text-gray-900 text-lg mb-2">Create Group</h3>
            <p className="text-gray-600 text-sm">Add new patient groups</p>
          </div>
        </CardContent>
      </Card>

      <Card 
        className="cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-0 shadow-lg group rounded-2xl overflow-hidden"
        onClick={onArchivedGroupsClick}
        data-testid="ea-archived-groups-card"
      >
        <CardContent className="p-8 text-center relative">
          <div className="absolute inset-0 bg-gradient-to-br from-teal-500/10 to-emerald-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="relative">
            <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Archive className="h-8 w-8 text-white" />
            </div>
            <h3 className="font-bold text-gray-900 text-lg mb-2">Archived Groups</h3>
            <p className="text-gray-600 text-sm">View archived records</p>
          </div>
        </CardContent>
      </Card>

      <Card 
        className="cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-0 shadow-lg group rounded-2xl overflow-hidden"
        onClick={onManageVPEClick}
        data-testid="ea-manage-vpe-card"
      >
        <CardContent className="p-8 text-center relative">
          <div className="absolute inset-0 bg-gradient-to-br from-green-500/10 to-lime-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="relative">
            <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-lime-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Settings className="h-8 w-8 text-white" />
            </div>
            <h3 className="font-bold text-gray-900 text-lg mb-2">Manage VPE</h3>
            <p className="text-gray-600 text-sm">VPE configurations</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ActionCardsSection;